import React, { Fragment } from 'react';
import { Container } from '@mui/material';
//
import TransactionHistoryTable from './TransactionHistoryTable';
import { useGetWLIDDropdownQuery } from '../../../store/api/wl.api';

const ClientTransactions = () => {
  // hooks
  const { data: wlidOptions = [] } = useGetWLIDDropdownQuery();

  return (
    <Fragment>
      <Container maxWidth='100%'>
        <TransactionHistoryTable clientOptionsData={wlidOptions} />
      </Container>
    </Fragment>
  );
};
export default ClientTransactions;
